<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Work Order Code</label>
              <vs-input type="text" class="w-full"
                        v-model="filters['wo_code']"
                        @keyup.enter="getTraceabilityReportData"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">ITS Product Code</label>
              <vs-input type="text" class="w-full"
                        v-model="filters['prod_code']"
                        @keyup.enter="getTraceabilityReportData"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Raw Material Code</label>
              <vs-input type="text" class="w-full"
                        v-model="filters['rm_code']"
                        @keyup.enter="getTraceabilityReportData"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Finished Good Code</label>
              <vs-input type="text" class="w-full"
                        v-model="filters['fg_code']"
                        @keyup.enter="getTraceabilityReportData"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Sales Order Number</label>
              <vs-input type="text" class="w-full"
                        v-model="filters['so_no']"
                        @keyup.enter="getTraceabilityReportData"/>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full md:w-6/6">
              <div class="btn-group float-right">
                <vs-button color="danger" size="small" @click="onClickClearSearch">Clear</vs-button>
                <vs-button class="ml-2" color="success" size="small" @click="getTraceabilityReportData">Search</vs-button>
              </div>
            </div>
          </div>
  </vx-card>
  <vx-card v-if="is_loaded" title="Traceability Audit">
    <vs-table :max-items="(meta.per_page) ? meta.per_page : 10"
              stripe :data="traceabilityData" :sst="true"
              class="table-dark-inverted table-auto vs-con-loading__container" id="traceability-audit-table">
      <template slot="thead">
        <vs-th width="15%">Formulation Code</vs-th>
        <vs-th width="15%">Work Order Code</vs-th>
        <vs-th width="10%">Customers Affected</vs-th>
        <vs-th width="20%">Work Order Date</vs-th>
        <vs-th width="20%">Status</vs-th>
        <vs-th width="10%">QC Status</vs-th>
        <vs-th width="10%">Actions</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <vx-tooltip class="text-primary cursor-pointer" text="View Formulation" position="top">
              <span @click.stop="onClickFormulationView(tr.formulation_id)">
                 {{ tr.formulation_code }}
              </span>
            </vx-tooltip>
          </vs-td>
          <vs-td>
            <vx-tooltip class="text-primary cursor-pointer" text="View Work Order" position="top">
              <span @click.stop="onClickWorkOrderView(tr.id)">
                 {{ tr.work_order_code }}
              </span>
            </vx-tooltip>
          </vs-td>
          <vs-td>
            {{ customerAffectedCounter(tr.order_items) }}
          </vs-td>
          <vs-td>
            {{ tr.work_order_date || 'N/A' }}
          </vs-td>
          <vs-td>
            {{ tr.status }}
          </vs-td>
          <vs-td>
            {{ tr.q_c_status || 'N/A'}}
          </vs-td>
          <vs-td>
            <div class="vx-row">
              <vx-tooltip class="mr-2" :text="`Download Report (${tr.work_order_code})`" position="bottom">
                <vs-button class="ml-3"
                           @click.stop="onClickDownloadReport(tr.id, tr.work_order_code)"
                           size="small" color="warning" type="border" icon-pack="feather" icon="icon-printer"></vs-button>
              </vx-tooltip>
            </div>
          </vs-td>

          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full px-8">

              <vs-table v-if="tr.stock_details.length > 0" class="my-8" hoverFlat id="stock_item_table" :data="tr.stock_details" stripe>
                <template slot="header">
                  <h5 class="mb-4 text-warning">Stock Details</h5>
                </template>
                <template slot="thead">
                  <vs-th>Total Quantity (KG)</vs-th>
                  <vs-th>Available Quantity (KG)</vs-th>
                  <vs-th>Manufacture Date</vs-th>
                  <vs-th>Expiration Date</vs-th>
                  <vs-th>Status</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index_item"
                         v-for="(tr_item, index_item) in data">
                    <vs-td>
                      {{ tr_item.total_quantity }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.available_quantity }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.manufacture_date }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.expiration_date }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.status }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-table v-if="tr.order_items.length > 0" class="my-8" hoverFlat id="order_item_table" :data="tr.order_items" stripe>
                <template slot="header">
                  <h5 class="mb-4 text-warning">Order Items</h5>
                </template>
                <template slot="thead">
                  <vs-th>Order Code</vs-th>
                  <vs-th>Customer</vs-th>
                  <vs-th>Order Quantity (KG)</vs-th>
                  <vs-th>WO Quantity (KG)</vs-th>
                  <vs-th>Price (GBP)</vs-th>
                  <vs-th>Order Status</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index_item"
                         v-for="(tr_item, index_item) in data">
                    <vs-td>
                      <span class="text-primary cursor-pointer" @click.stop="onClickOrderDetailsView(tr_item.order_id)">
                         {{ tr_item.product_order_code }}
                      </span>
                    </vs-td>
                    <vs-td>
                      {{ tr_item.customer }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.order_quantity }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.wo_quantity }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.price }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.item_status }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-table v-if="tr.raw_material_stock_inventory.length > 0" class="my-8" hoverFlat id="rm_stock_table" :data="tr.raw_material_stock_inventory" stripe>
                <template slot="header">
                  <h5 class="mb-4 text-warning">RM used to make the WO</h5>
                </template>
                <template slot="thead">
                  <vs-th>Batch Code</vs-th>
                  <vs-th>RM CODE/NAME</vs-th>
                  <vs-th>SUPPLIER BATCH NUMBER</vs-th>
                  <vs-th>Batch Quantity Received</vs-th>
                  <vs-th>Batch Quantity Unallocated</vs-th>
                  <vs-th>Quantity Used in WO</vs-th>
                  <vs-th>Batch Manufacture Date</vs-th>
                  <vs-th>Batch Expiration Date</vs-th>
                  <vs-th>Status</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr class="cursor-pointer" @click.native="onClickRmStock(tr_item.raw_material_code)" :key="index_item"
                         v-for="(tr_item, index_item) in data">
                    <vs-td>
                      {{ tr_item.batch_code || ''}}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.raw_material_code || '' }} ( {{ tr_item.raw_material_name || ''}} )
                    </vs-td>
                    <vs-td>
                      {{ tr_item.supplier_batch_no || ''}}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.total_quantity || ''}}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.available_quantity || ''}}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.quantity_used_in_wo || ''}}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.manufacture_date || ''}}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.expiration_date || ''}}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.status || ''}}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-table v-if="tr.formulation_stock_inventory.length > 0" class="my-8" hoverFlat id="fg_stock_table" :data="tr.formulation_stock_inventory" stripe>
                <template slot="header">
                  <h5 class="mb-4 text-warning">FG used to make the WO</h5>
                </template>
                <template slot="thead">
                  <vs-th>WO Code</vs-th>
                  <vs-th>FG CODE</vs-th>
                  <vs-th>Total Quantity</vs-th>
                  <vs-th>Completed Quantity</vs-th>
                  <vs-th>Quantity Used in WO</vs-th>
                  <vs-th>Batch Manufacture Date</vs-th>
                  <vs-th>Batch Expiration Date</vs-th>
                  <vs-th>Status</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index_item"
                         v-for="(tr_item, index_item) in data">
                    <vs-td>
                      {{ tr_item.work_order_code }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.formulation_code }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.total_quantity }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.completed_quantity }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.quantity_used_in_wo }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.manufacture_date }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.expiration_date }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.status }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </template>
        </vs-tr>
      </template>

  </vs-table>
    <vs-pagination
      v-on:changeMaxItems="changePage"
      :size-array="meta.total ? meta.total : 20"
      :max-items="perPage"
      description-body="Rows per page"
      description-connector="of"
      description-title="Records"
      description
      :description-items="descriptionItems"
      :total="(meta.last_page)? meta.last_page : 0"
      v-model="page"  class="p-5">
    </vs-pagination>
  </vx-card>
      </div>
    </div>
  </div>

</template>

<script>

import {RepositoryFactory} from "@/repository/RepositoryFactory";
import {defaultPagination, perPageList} from "@/constants/config";

const ReportingRepository = RepositoryFactory.get('reporting')

export default {
  name: "TraceabilityAudit",
  data(){
    return{
      traceabilityData: [],
      meta:{},
      maxItems:20,
      page : 1,
      total: 0,
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      filters: {
        wo_code: '',
        rm_code: '',
        fg_code: '',
        so_no: '',
        prod_code: '',
      },
      is_loaded: false,
    }
  },
  methods:{
    async getTraceabilityReportData() {
      try {
          this.is_loaded = false
          this.traceabilityData = []
          const filterQuery = `filter[rm_code]=${this.filters.rm_code}&filter[wo_code]=${this.filters.wo_code}&filter[fg_code]=${this.filters.fg_code}&filter[prod_code]=${this.filters.prod_code}&filter[so_no]=${this.filters.so_no}&`
          await this.$vs.loading()
          const {data} = await ReportingRepository.getTraceabilityData(this.page, filterQuery, this.perPage)
          this.traceabilityData = data.data
          this.meta = data.meta
          this.is_loaded = true
      }catch (error) {
        //
      }
      this.$vs.loading.close()
    },
    async onClickClearSearch() {
      this.filters = {
        wo_code: '',
        rm_code: '',
        fg_code: '',
        so_no: '',
        prod_code: '',
      }
      await this.getTraceabilityReportData()
    },
    async onClickOrderDetailsView (id) {
      let route = this.$router.resolve({path: `/pages/product-orders/${id}`});
      window.open(route.href, '_blank');
    },
    async onClickFormulationView (id) {
      let route = this.$router.resolve({path: `/pages/formulations/${id}`});
      window.open(route.href, '_blank');
    },
    async onClickWorkOrderView (id) {
      let route = this.$router.resolve({path: `/pages/manufacturing/work-orders/${id}/details`});
      window.open(route.href, '_blank');
    },
    customerAffectedCounter(order_items) {
      let tempResult = {}

      for(let { customer } of order_items)
        tempResult[customer] = customer

      let result = Object.values(tempResult)
      return result.length
    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
    async onClickDownloadReport(wo_id, wo_code) {
      this.$vs.loading()
      try {
        const response = await ReportingRepository.downloadTraceabilityReport(wo_id)
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `Traceability Report (${wo_code}).xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
      } catch (e) {

      }
      this.$vs.loading.close()
    },
    async onClickRmStock(rm_code) {
      await this.$router.push(`/pages/stock-check?search=${rm_code}`)
    },
  },
  watch : {
    page(){
      this.getTraceabilityReportData()
    },
    perPage() {
      this.getTraceabilityReportData()
    }
  }
}
</script>

<style scoped>

</style>
